import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { Result, Button } from 'antd'
import { useSelector } from 'react-redux'
import { RootState } from '../store'
import {
  collectUserRoles,
  isEditorialCommitteeMember,
} from '../constants/editorialRoles'

interface RequireEditorialCommitteeProps {
  children: React.ReactNode
}

/**
 * 路由守卫：仅已登录且具备编写委员会角色（AUTHOR / DEPUTY_EDITOR / EDITOR_IN_CHIEF / ADMIN）可访问
 */
const RequireEditorialCommittee: React.FC<RequireEditorialCommitteeProps> = ({
  children,
}) => {
  const location = useLocation()
  const { isAuthenticated, roles, user } = useSelector(
    (state: RootState) => state.auth
  )

  if (!isAuthenticated) {
    const redirect = encodeURIComponent(
      location.pathname + location.search
    )
    return <Navigate to={`/auth/login?redirect=${redirect}`} replace />
  }

  const allRoles = collectUserRoles(roles, user?.role)
  if (!isEditorialCommitteeMember(allRoles)) {
    return (
      <Result
        status="403"
        title="无权访问"
        subTitle="智能写书与编写任务仅对编写委员会成员开放。如需使用，请联系管理员分配 AUTHOR / DEPUTY_EDITOR / EDITOR_IN_CHIEF 等角色。"
        extra={
          <Button type="primary" onClick={() => window.history.back()}>
            返回上一页
          </Button>
        }
      />
    )
  }

  return <>{children}</>
}

export default RequireEditorialCommittee
